export enum Delimiter {
  SPACE = 'space',
  COMMA = 'comma',
  SEMI_COLON = 'semi_colon',
  NEW_LINE = 'new_line',
  OTHER = 'other',
}
